import type { UseQueryResult } from '@tanstack/react-query';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import type { SigningJwtQuery } from '../data/signing.generated';
import { useSigningJwtQuery } from '../data/signing.generated';

dayjs.extend(duration);

const defaultRefetchInterval = dayjs.duration({ minutes: 1 }).asMilliseconds();

/**
 * Fetches the JWT token used for signing.
 * Token is refreshed automatically
 */
type PpUseSigningJwt = {
  enabled?: boolean;
};
export function useSigningJwt({ enabled = false }: PpUseSigningJwt = {}): UseQueryResult<
  SigningJwtQuery,
  unknown
> {
  return useSigningJwtQuery(undefined, {
    enabled,
    refetchInterval: defaultRefetchInterval,
  });
}
